import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getWarehouseList } from '@/service/proRequisition';
export default function useDefaultWarehouse() {
  var defaultWarehouse = ref();
  var getDefaultWarehouseAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getWarehouseList({
              limit: 10,
              page: 1,
              warehouse_name: '备品备件'
            });
          case 2:
            data = _context.sent;
            // console.log('getWarehouseList datadatadatadatadatadata...');
            // console.dir(data);
            if (data.data && data.data.length) {
              defaultWarehouse.value = data.data[0];
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getDefaultWarehouseAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [defaultWarehouse, getDefaultWarehouseAsync];
}